(function () {
  'use strict';
  if (document.__skBuyingGuide) return;
  document.__skBuyingGuide = true;
  var categories = ['filament', '3dprinter-all', '3d-scanner'];
  var intents = ['guide', 'compare', 'experience', 'consultation'];
  if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-sk-buying-guide] a');
    if (!link) return;
    var section = link.closest('[data-sk-buying-guide]');
    var category = section.dataset.skBuyingGuide;
    if (section.dataset.skGuideTracking !== 'true' || !categories.includes(category)) return;
    var intent = link.dataset.skGuideIntent;
    if (!intent) {
      var path = link.getAttribute('href') || '';
      if (path.startsWith('/collections/')) intent = 'products';
      else if (path.startsWith('/blogs/')) intent = 'guide';
    }
    if (!intents.includes(intent) && intent !== 'products') return;
    try {
      if (!window.Shopify || window.Shopify.designMode || window.Shopify.customerPrivacy.analyticsProcessingAllowed() !== true) return;
      var payload = { guide_category: category, guide_intent: intent, guide_placement: 'category_before_grid' };
      if (typeof window.gtag === 'function') window.gtag('event', 'buying_guide_click', payload);
      else if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: 'buying_guide_click' }, payload));
    } catch (_) { /* Navigation remains available if analytics is unavailable. */ }
  });
}());
